module.exports = __webpack_public_path__ + "img/end.896ad5dd.png";